import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class JurisdictionsService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/', {
        jurisdiction: 'jurisdiction',
      }),
    }
  }

  static create() {
    return new JurisdictionsService()
  }

  async getJurisdictionsPublic(params = {}) {
    params.size = params.size ?? 300
    params.search = params.search || ''
    const servicePath = this.endpoints.jurisdiction()
    const { data } = await axios.get(servicePath, { params })
    const { content } = data
    return content
  }
}
